var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    {
      class: "notification-item " + (_vm.item.unread ? "unread" : ""),
      on: {
        click: function ($event) {
          return _vm.goDetailAction()
        },
      },
    },
    [
      _c("v-list-item-avatar", [
        _c("img", {
          attrs: {
            src:
              _vm.item.target &&
              _vm.item.target.user &&
              _vm.item.target.user.image
                ? _vm.item.target.user.image.url
                : "/assets/user-958851872d7a849ea34d9887d31e41ce820428c6fccef8cb62b595382379b407.png",
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "v-list-item-content",
        [
          _vm.item.target && _vm.item.target.user
            ? _c("v-list-item-title", {
                domProps: { innerHTML: _vm._s(_vm.item.target.user.name) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-list-item-subtitle", [
            _vm._v(
              _vm._s(
                _vm.item.message
                  ? _vm.item.message
                  : _vm.$t("notification_action." + _vm.item.action)
              )
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }